import { useState } from "react";
import { fileUrl } from "@/lib/api";
import { X, PlayCircle, ZoomIn } from "lucide-react";

export const isVideoPath = (p) => /\.(mp4|mov|webm|m4v|3gp|mkv|avi)$/i.test(p || "");

export default function MediaViewer({ path, label = "media", className = "h-20", testId = "media" }) {
  const [open, setOpen] = useState(false);
  if (!path) return null;
  const url = fileUrl(path);
  const video = isVideoPath(path);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`relative w-full ${className} rounded border border-[#28364F] overflow-hidden group bg-black`}
        data-testid={`${testId}-thumb`}
        aria-label={`Open ${label}`}
      >
        {video ? (
          <video src={url} className="w-full h-full object-cover" muted playsInline preload="metadata" />
        ) : (
          <img src={url} alt={label} className="w-full h-full object-cover" />
        )}
        <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-70 group-hover:opacity-100 transition-opacity">
          {video ? <PlayCircle className="w-7 h-7 text-white" /> : <ZoomIn className="w-6 h-6 text-white" />}
        </div>
        <span className="absolute bottom-1 left-1 text-[9px] uppercase tracking-widest bg-black/70 px-1.5 py-0.5 rounded text-white">{label}</span>
      </button>
      {open && (
        <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-3" onClick={() => setOpen(false)} data-testid={`${testId}-lightbox`}>
          <button type="button" className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 rounded-full p-2 text-white"
            onClick={() => setOpen(false)} data-testid={`${testId}-lightbox-close`} aria-label="Close">
            <X className="w-6 h-6" />
          </button>
          <div className="max-w-5xl w-full max-h-[90vh] flex flex-col items-center gap-2" onClick={(e) => e.stopPropagation()}>
            {video ? (
              <video src={url} controls autoPlay playsInline className="max-h-[85vh] max-w-full rounded-lg" />
            ) : (
              <img src={url} alt={label} className="max-h-[85vh] max-w-full object-contain rounded-lg" />
            )}
            <div className="text-xs uppercase tracking-widest text-[#94A3B8]">{label} — tap outside to close</div>
          </div>
        </div>
      )}
    </>
  );
}
